import { render, staticRenderFns } from "./horc-icon.vue?vue&type=template&id=55fffbe0"
import script from "./horc-icon.vue?vue&type=script&lang=js"
export * from "./horc-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports